import { blogPosts } from "@nls-2022/nls-api/src/apiConsts";
import {
  FACompBlogContentType,
  FACompResultBlogContentType,
  BlogGenericContentType,
  BlogContentType,
} from "../../types/blog/blogContentTypes";
import { TwitterGenericContentType } from "../../types/blog/twitterContentTypes";
import {
  generateTitle,
  initBlogPostContent,
} from "./generateBlogPostContentUtils";
import {
  getFACompByType,
  getSponsorBySponsorName,
} from "../filters/filterPostsRefData";
import { formatDate } from "../../common/utils";
export const generateTwitterPostContentFromCompResultBlogPost = (
  compBlogPost: FACompResultBlogContentType | undefined
): TwitterGenericContentType => {
  if (compBlogPost === undefined) return initBlogPostContent();
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const sponsor = getSponsorBySponsorName(
    getFACompByType(compBlogPost!.comp)!.sponsorName
  );
  //const roundDate = new Date(compBlogPost.roundDate);
  const today = new Date();

  // let roundDateString =
  //  roundDate.getDate().toString() +
  //  " " +
  //  months[roundDate.getMonth()] +
  //  " " +
  //  roundDate.getFullYear().toString();
  const season: string =
    compBlogPost.season === undefined ? "" : compBlogPost.season;
  const title: string = undefined
    ? ""
    : getFACompByType(compBlogPost!.comp)!.name + " " + compBlogPost.title;
  const excerpt: string = undefined
    ? ""
    : compBlogPost.winningClubDetail?.ClubName ??
      "" +
        " who are the champions of " +
        " of the " +
        compBlogPost.season +
        " " +
        sponsor!.sponsorName +
        " " +
        getFACompByType(compBlogPost!.comp)!.name;

  let otherText = compBlogPost!.aet ? " after extra time " : "";
  otherText = compBlogPost!.pens ? " on penalties " : otherText;

  const content = `Congratulations to ${
    compBlogPost.winningClubDetail?.ClubName ?? ""
  } who are the ${compBlogPost.season} ${sponsor!.sponsorName} ${
    getFACompByType(compBlogPost!.comp)!.name
  } champions. `;

  let twitterPostContent: TwitterGenericContentType = {
    content: content,
  };
  return twitterPostContent;
};
